export default function(onenter, onupdate, onexit) {
  var enter = this.enter(), update = this, exit = this.exit();
  enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
  if (onupdate != null) update = onupdate(update);
  if (onexit == null) exit.remove(); else onexit(exit);
  return enter && update ? enter.merge(update).order() : update;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selection/join.js
// module id = ./node_modules/d3-selection/src/selection/join.js
// module chunks = 54